import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { Note } from '@tv3/store/note/note.model'
import { EditNoteDialogComponent } from '@tv3/containers/inquiries/dialogs/notes/note/edit-note-dialog/edit-note-dialog.component'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'

@Injectable()
export class EditNoteDialogService {
  constructor(private dialog: MatDialog) {}

  open(data: any = { inquiry: Inquiry, note: Note }) {
    let defaultConfig: MatDialogConfig = {
      width: '600px',
      height: 'auto',
      panelClass: ['fixed-modal'],
      data,
    }

    return this.dialog.open(EditNoteDialogComponent, defaultConfig)
  }
}
